// GENERATED by scripts/gen-icons.mjs — do not edit.
// Run `npm run gen:icons` after bumping lucide-react.

import {
    Amphora,
    Anchor,
    Angle,
    Antenna,
    Anvil,
    Aperture,
    AppWindow,
    AppWindowMac,
    Apple,
    Archive,
    ArchiveRestore,
    ArchiveX,
    Armchair,
    ArrowBigDown,
    ArrowBigDownDash,
    ArrowBigLeft,
    ArrowBigLeftDash,
    ArrowBigRight,
    ArrowBigRightDash,
    ArrowBigUp,
    ArrowBigUpDash,
    ArrowDown,
    ArrowDown01,
    ArrowDown10,
    ArrowDownAZ,
    ArrowDownFromLine,
    ArrowDownLeft,
    ArrowDownNarrowWide,
    ArrowDownRight,
    ArrowDownToDot,
    ArrowDownToLine,
    ArrowDownUp,
    ArrowDownWideNarrow,
    ArrowDownZA,
    ArrowLeft,
    ArrowLeftFromLine,
    ArrowLeftRight,
    ArrowLeftToLine,
    ArrowRight,
    ArrowRightFromLine,
} from "lucide-react";
import type { LucideIcon } from "lucide-react";

/** The 40 lucide icons from "amphora" through "arrow-right-from-line", inclusive. */
const shard: Record<string, LucideIcon> = {
    amphora: Amphora,
    anchor: Anchor,
    angle: Angle,
    antenna: Antenna,
    anvil: Anvil,
    aperture: Aperture,
    "app-window": AppWindow,
    "app-window-mac": AppWindowMac,
    apple: Apple,
    archive: Archive,
    "archive-restore": ArchiveRestore,
    "archive-x": ArchiveX,
    armchair: Armchair,
    "arrow-big-down": ArrowBigDown,
    "arrow-big-down-dash": ArrowBigDownDash,
    "arrow-big-left": ArrowBigLeft,
    "arrow-big-left-dash": ArrowBigLeftDash,
    "arrow-big-right": ArrowBigRight,
    "arrow-big-right-dash": ArrowBigRightDash,
    "arrow-big-up": ArrowBigUp,
    "arrow-big-up-dash": ArrowBigUpDash,
    "arrow-down": ArrowDown,
    "arrow-down-0-1": ArrowDown01,
    "arrow-down-1-0": ArrowDown10,
    "arrow-down-a-z": ArrowDownAZ,
    "arrow-down-from-line": ArrowDownFromLine,
    "arrow-down-left": ArrowDownLeft,
    "arrow-down-narrow-wide": ArrowDownNarrowWide,
    "arrow-down-right": ArrowDownRight,
    "arrow-down-to-dot": ArrowDownToDot,
    "arrow-down-to-line": ArrowDownToLine,
    "arrow-down-up": ArrowDownUp,
    "arrow-down-wide-narrow": ArrowDownWideNarrow,
    "arrow-down-z-a": ArrowDownZA,
    "arrow-left": ArrowLeft,
    "arrow-left-from-line": ArrowLeftFromLine,
    "arrow-left-right": ArrowLeftRight,
    "arrow-left-to-line": ArrowLeftToLine,
    "arrow-right": ArrowRight,
    "arrow-right-from-line": ArrowRightFromLine,
};

export default shard;
